module.exports = __webpack_public_path__ + "img/III-72.92b93b05.svg";